import {
  FETCH_ROLES_END,
  FETCH_ROLES_START,
  SAVE_ROLES,
  SAVE_ROLES_START
} from "appRedux/constants";

const INIT_STATE = {
  loading: false,
  roles: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ROLES_START: {
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_ROLES_END: {
      return {
        ...state,
        loading: false
      };
    }
    case SAVE_ROLES_START: {
      return {
        ...state,
        loading: true
      };
    }
    case SAVE_ROLES: {
      return {
        ...state,
        loading: false,
        roles: action.payload
      };
    }
    default:
      return state;
  }
};
